$ = require 'jquery'
Confirm = require 'views/lib/confirm'
PopOver = require 'views/lib/pop-over'
l = require 'lib/localize'

canAddCard = (board, list) ->
  !board?.isOverLimit('cards', 'openPerBoard') &&
  !board?.isOverLimit('cards', 'totalPerBoard') &&
  !list?.isOverLimit('cards', 'openPerList') &&
  !list?.isOverLimit('cards', 'totalPerList')

maybeDisplayCardLimitsError = (e, board, list) ->
  exceededLimitMessage = null
  if board?.isOverLimit('cards', 'openPerBoard')
    exceededLimitMessage = 'card exceeds open per board limit'
  else if board?.isOverLimit('cards', 'totalPerBoard')
    exceededLimitMessage = 'card exceeds total per board limit'
  else if list?.isOverLimit('cards', 'openPerList')
    exceededLimitMessage = 'card exceeds open per list limit'
  else if list?.isOverLimit('cards', 'totalPerList')
    exceededLimitMessage = 'card exceeds total per list limit'

  if exceededLimitMessage?
    Confirm.toggle exceededLimitMessage,
      elem: $(e.target)
      html: l "confirm.#{exceededLimitMessage}.text",
          { boardName: board?.get("name"), listName: list?.get("name") }
      fxConfirm: (e) =>
        PopOver.hide()
    return true
  return false

module.exports = { canAddCard, maybeDisplayCardLimitsError }


// WEBPACK FOOTER //
// ./app/scripts/views/card/card-limits-error.coffee